"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Query = void 0;
var query_part_1 = require("./query-part");
var Query = /** @class */ (function () {
    function Query(provider, parts) {
        if (parts === void 0) { parts = []; }
        this.provider = provider;
        this.parts = parts;
    }
    Query.prototype.aggregate = function (func, seed) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.aggregate(func, seed, scopes)]));
    };
    Query.prototype.aggregateAsync = function (func, seed) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.aggregate(func, seed, scopes)]));
    };
    Query.prototype.all = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.all(predicate, scopes)]));
    };
    Query.prototype.allAsync = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.all(predicate, scopes)]));
    };
    Query.prototype.any = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.any(predicate, scopes)]));
    };
    Query.prototype.anyAsync = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.any(predicate, scopes)]));
    };
    Query.prototype.average = function (selector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.average(selector, scopes)]));
    };
    Query.prototype.averageAsync = function (selector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.average(selector, scopes)]));
    };
    Query.prototype.cast = function (type) {
        return this.create(query_part_1.QueryPart.cast(type));
    };
    Query.prototype.concat = function (other) {
        return this.create(query_part_1.QueryPart.concat(other));
    };
    Query.prototype.contains = function (item, comparer) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.contains(item, comparer, scopes)]));
    };
    Query.prototype.containsAsync = function (item, comparer) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.contains(item, comparer, scopes)]));
    };
    Query.prototype.count = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.count(predicate, scopes)]));
    };
    Query.prototype.countAsync = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.count(predicate, scopes)]));
    };
    Query.prototype.defaultIfEmpty = function (defaultValue) {
        return this.create(query_part_1.QueryPart.defaultIfEmpty(defaultValue));
    };
    Query.prototype.distinct = function (comparer) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.distinct(comparer, scopes));
    };
    Query.prototype.elementAt = function (index) {
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.elementAt(index)]));
    };
    Query.prototype.elementAtAsync = function (index) {
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.elementAt(index)]));
    };
    Query.prototype.elementAtOrDefault = function (index) {
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.elementAtOrDefault(index)]));
    };
    Query.prototype.elementAtOrDefaultAsync = function (index) {
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.elementAtOrDefault(index)]));
    };
    Query.prototype.except = function (other, comparer) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.except(other, comparer, scopes));
    };
    Query.prototype.first = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.first(predicate, scopes)]));
    };
    Query.prototype.firstAsync = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.first(predicate, scopes)]));
    };
    Query.prototype.firstOrDefault = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.firstOrDefault(predicate, scopes)]));
    };
    Query.prototype.firstOrDefaultAsync = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.firstOrDefault(predicate, scopes)]));
    };
    Query.prototype.groupBy = function (keySelector, elementSelector, ctor) {
        var scopes = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            scopes[_i - 3] = arguments[_i];
        }
        return this.fixCtorArg(function (s) { return query_part_1.QueryPart.groupBy(keySelector, elementSelector, s); }, ctor, scopes);
    };
    Query.prototype.groupJoin = function (other, thisKey, otherKey, selector, ctor) {
        var scopes = [];
        for (var _i = 5; _i < arguments.length; _i++) {
            scopes[_i - 5] = arguments[_i];
        }
        return this.fixCtorArg(function (s) { return query_part_1.QueryPart.groupJoin(other, thisKey, otherKey, selector, s); }, ctor, scopes);
    };
    Query.prototype.inlineCount = function () {
        return this.create(query_part_1.QueryPart.inlineCount());
    };
    Query.prototype.intersect = function (other, comparer) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.intersect(other, comparer, scopes));
    };
    Query.prototype.join = function (other, thisKey, otherKey, selector, ctor) {
        var scopes = [];
        for (var _i = 5; _i < arguments.length; _i++) {
            scopes[_i - 5] = arguments[_i];
        }
        return this.fixCtorArg(function (s) { return query_part_1.QueryPart.join(other, thisKey, otherKey, selector, s); }, ctor, scopes);
    };
    Query.prototype.last = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.last(predicate, scopes)]));
    };
    Query.prototype.lastAsync = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.last(predicate, scopes)]));
    };
    Query.prototype.lastOrDefault = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.lastOrDefault(predicate, scopes)]));
    };
    Query.prototype.lastOrDefaultAsync = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.lastOrDefault(predicate, scopes)]));
    };
    Query.prototype.max = function (selector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.max(selector, scopes)]));
    };
    Query.prototype.maxAsync = function (selector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.max(selector, scopes)]));
    };
    Query.prototype.min = function (selector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.min(selector, scopes)]));
    };
    Query.prototype.minAsync = function (selector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.min(selector, scopes)]));
    };
    Query.prototype.ofGuardedType = function (checker) {
        return this.create(query_part_1.QueryPart.ofGuardedType(checker));
    };
    Query.prototype.ofType = function (type) {
        var ctor = typeof type === "function" ? type : type.constructor;
        return this.create(query_part_1.QueryPart.ofType(ctor)).cast(ctor);
    };
    Query.prototype.orderBy = function (keySelector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.orderBy(keySelector, scopes));
    };
    Query.prototype.orderByDescending = function (keySelector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.orderByDescending(keySelector, scopes));
    };
    Query.prototype.reverse = function () {
        return this.create(query_part_1.QueryPart.reverse());
    };
    Query.prototype.select = function (selector, ctor) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.fixCtorArg(function (s) { return query_part_1.QueryPart.select(selector, s); }, ctor, scopes);
    };
    Query.prototype.selectMany = function (selector, ctor) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.fixCtorArg(function (s) { return query_part_1.QueryPart.selectMany(selector, s); }, ctor, scopes);
    };
    Query.prototype.sequenceEqual = function (other, comparer) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.sequenceEqual(other, comparer, scopes)]));
    };
    Query.prototype.sequenceEqualAsync = function (other, comparer) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.sequenceEqual(other, comparer, scopes)]));
    };
    Query.prototype.single = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.single(predicate, scopes)]));
    };
    Query.prototype.singleAsync = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.single(predicate, scopes)]));
    };
    Query.prototype.singleOrDefault = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.singleOrDefault(predicate, scopes)]));
    };
    Query.prototype.singleOrDefaultAsync = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.singleOrDefault(predicate, scopes)]));
    };
    Query.prototype.skip = function (count) {
        return this.create(query_part_1.QueryPart.skip(count));
    };
    Query.prototype.skipWhile = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.skipWhile(predicate, scopes));
    };
    Query.prototype.sum = function (selector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.execute(__spread(this.parts, [query_part_1.QueryPart.sum(selector, scopes)]));
    };
    Query.prototype.sumAsync = function (selector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [query_part_1.QueryPart.sum(selector, scopes)]));
    };
    Query.prototype.take = function (count) {
        return this.create(query_part_1.QueryPart.take(count));
    };
    Query.prototype.takeWhile = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.takeWhile(predicate, scopes));
    };
    Query.prototype.thenBy = function (keySelector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.thenBy(keySelector, scopes));
    };
    Query.prototype.thenByDescending = function (keySelector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.thenByDescending(keySelector, scopes));
    };
    Query.prototype.union = function (other, comparer) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.union(other, comparer, scopes));
    };
    Query.prototype.where = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.create(query_part_1.QueryPart.where(predicate, scopes));
    };
    Query.prototype.zip = function (other, selector, ctor) {
        var scopes = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            scopes[_i - 3] = arguments[_i];
        }
        return this.fixCtorArg(function (s) { return query_part_1.QueryPart.zip(other, selector, s); }, ctor, scopes);
    };
    Query.prototype.toArray = function (ctor) {
        var query = ctor ? this.cast(ctor) : this;
        return query.provider.execute(__spread(query.parts, [query_part_1.QueryPart.toArray()]));
    };
    Query.prototype.toArrayAsync = function (ctor) {
        var query = ctor ? this.cast(ctor) : this;
        return query.provider.executeAsync(__spread(query.parts, [query_part_1.QueryPart.toArray()]));
    };
    Query.prototype[Symbol.iterator] = function () {
        var result = this.provider.execute(this.parts);
        return result.value ? result.value : result;
    };
    Query.prototype.create = function (part) {
        return this.provider.createQuery(__spread(this.parts, [part]));
    };
    Query.prototype.fixCtorArg = function (partCurry, ctor, scopes) {
        if (ctor && typeof ctor !== "function") {
            scopes = __spread([ctor], scopes);
            ctor = null;
        }
        var query = this.create(partCurry(scopes));
        return ctor ? query.cast(ctor) : query;
    };
    return Query;
}());
exports.Query = Query;
//# sourceMappingURL=query.js.map